import React, { useEffect, useState } from "react";
import "../../assets/styles/navbar.css";
import mainLogo from "../../assets/images/main-logo.png";
import logoDuns from "../../assets/images/logo-duns.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { config } from "../../pages/config";
import axios from "axios";

const Navbar = ({ onSearchResults }) => {
  const location = useLocation("");

  const [sideMenu, setSideMenu] = useState(false);
  const [sideMenuMobile, setSideMenuMobile] = useState(false);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".nav-item")) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  console.log(navigate);

  const handleSearch = () => {
    if (query.trim()) {
      navigate(`${config.appUrl}search/${query}`);
    }
  };
  return (
    <div>
      <header
        id="header"
        className={`headroom ${isSticky ? 'sticky' : ''}`}
      >
        <div className="header-inner">
          <div className="container">
            <nav className="navbar navbar-expand-md navbar-light">
              {/* <div> */}
              <Link
                to={`${config.appUrl}`}
                className="navbar-brand d-flex gap-3 align-items-center logo-margin"
              >
                <img className="img-fluid" src={mainLogo} alt="logo" width="200" height="36" style={{ color: "transparent" }} />
              </Link>

              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <div className="search-container">
                  <form>
                    <input type="text" placeholder="Search By Code / Name / CAS" name="product" className="product-search"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)} required />
                    <button type="submit" className="search-btn" onClick={handleSearch}>
                      <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="7" stroke="black" stroke-width="2" />
                        <line x1="15" y1="15" x2="20" y2="20" stroke="black" stroke-width="2" />
                      </svg>
                    </button>
                  </form>
                </div>
                {/* <img className="img-fluid msds-logo" src={logoDuns} alt="logo" style={{ color: "transparent" }} /> */}
                <li
                  className={`nav-item ham-dot ${location?.pathname === `${config.appUrl}our-services` ? "active" : ""
                    }`}
                >
                  <a className="hammenu" onClick={toggleDropdown}>
                    <div className={`bar top-bar ${isDropdownOpen ? "rotate-45" : ""}`}></div>
                    <div className={`bar middle-bar ${isDropdownOpen ? "hidden" : ""}`}></div>
                    <div className={`bar bottom-bar ${isDropdownOpen ? "-rotate-45" : ""}`}></div>
                  </a>

                  <ul className={`dropdown-menu navham-dropdown ${isDropdownOpen ? "show" : ""}`}>
                    <li className="nav-item">
                      <Link className="nav-link navham-menu" to={`${config.appUrl}`}>
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link navham-menu" to={`${config.appUrl}about-us`}>
                        About Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link navham-menu" to={`${config.appUrl}product`}>
                        Product
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link navham-menu" to={`${config.appUrl}contact-us`}>
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </li>
              </div>
              <div className="mobile-action d-block d-xl-none">
                <div className="mobile-hamburger">
                  <a className="hamburger" onClick={() => setSideMenuMobile(true)}>
                    <span className="hamburger-container">
                      <span className="hamburger-inner"></span>
                      <span className="hamburger-hidden"></span>
                    </span>
                  </a>
                </div>
              </div>
              {/* </div> */}
            </nav>
            <div
              class={`offcanvas main-menu-offcanvas offcanvas-end  ${sideMenuMobile ? "show" : ""
                }`}
            >
              <div className="offcanvas-header">
                <a className="navbar-brand d-flex gap-2 align-items-center">
                  <img className="img-fluid" width="110" src={mainLogo} alt="logo" />
                  <h4 className="mb-0"></h4>
                </a>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSideMenuMobile(false)}
                >
                  <i className="bi bi-x"></i>
                </button>
              </div>
              <div className="offcanvas-body">

                <div className="body-inner">
                  <nav className="navbar">
                    <ul className="navbar-nav w-100">
                      <li className="nav-item ">
                        <Link to={`${config.appUrl}`} className="nav-link">
                          Home
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link to={`${config.appUrl}about-us`} className="nav-link">
                          About Us
                        </Link>
                      </li>
                      <li className="nav-item ">
                        <Link to={`${config.appUrl}contact-us`} className="nav-link">
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </nav>
                  <div className="bottom-info ">
                    <div className="contact-info border-0 pt-0">
                      <a href="tel:+91-8401206515" style={{ textDecoration: 'none' }} className="mail"><i className="bi bi-phone"></i>+91 84012 06515</a>
                      <a className="mail" href="mailto: info@elementeers.com">
                        <i className="bi bi-envelope"></i> info@elementeers.com
                      </a>
                      <span className="text">
                        Looking for collaboration for your next creative project?
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
